
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './schema';

export const SUPABASE_URL = "https://wwteeeifrhdxzjnefmfq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind3dGVlZWlmcmhkeHpqbmVmbWZxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI5MzEzODIsImV4cCI6MjA1ODUwNzM4Mn0.aSLpJ5O6gpi2m0mPwDiR0RrZjAUF7khd5bwzesJq6oE";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
